// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ideaEntity from './entities/idea.json';
import ideaMenu from '../pages/idea/menu.json';
import ideaFullForm from '../pages/idea/forms/full.json';
import ideaContextForm from '../pages/idea/forms/context.json';
import ideaMiniForm from '../pages/idea/forms/mini.json';
import ideaLookupForm from '../pages/idea/forms/lookup.json';
import ideaTableView from '../pages/idea/views/table.json';
import ideaStagesView from '../pages/idea/views/stages.json';
import ideaCardsView from '../pages/idea/views/cards.json';
import ideaInlineView from '../pages/idea/views/inline.json';
import ideaBacklogView from '../pages/idea/views/backlog.json';
import ideaSplitView from '../pages/idea/views/split.json';
import ideaCalendarView from '../pages/idea/views/calendar.json';
import ideaDashboardView from '../pages/idea/views/dashboard.json';
import ideaIcoverView from '../pages/idea/views/icover.json';

/** Тип запису «Ідея» зі сторінками пакета: меню, форми та подання з pages/idea/. */
export const ideaDefinition: IRecordTypeDefinition = {
  ...ideaEntity,
  views: assembleViewSet({
      table: ideaTableView,
      stages: ideaStagesView,
      cards: ideaCardsView,
      inline: ideaInlineView,
      backlog: ideaBacklogView,
      split: ideaSplitView,
      calendar: ideaCalendarView,
      dashboard: ideaDashboardView,
      icover: ideaIcoverView,
  }),
  form: ideaFullForm,
  forms: { full: ideaFullForm, context: ideaContextForm, mini: ideaMiniForm, lookup: ideaLookupForm },
  menu: ideaMenu,
} as IRecordTypeDefinition;
